module.exports = __webpack_public_path__ + "static/img/preview-02.1dad0dda.webp";